import { render, staticRenderFns } from "./MMSetting.vue?vue&type=template&id=639e1294&"
import script from "./MMSetting.vue?vue&type=script&lang=js&"
export * from "./MMSetting.vue?vue&type=script&lang=js&"
import style0 from "./MMSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports